import { debounce } from "./common";
import { plotlineArrayFunc } from "./config";


export const getDataWithoutAlertAlarm = data => {
  if (data && data.length) {
    return data.filter(dataArr => {
      return (
        dataArr.state !== "open"
      );
    });
  }
};
